import { GET, PATCH, POST } from "../../../../../helper/xbi4RestFunctions";
export const getQuereyByResponseQueryId = async (
  org_id: any,
  personal_faq_id: any
) => {
  const path = `/orgs/${org_id}/personal_queries/response/${personal_faq_id}
  `;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
